import { TIME_ZONES } from "./TIME_ZONES";

export const TIME_ZONES_NAMES = TIME_ZONES.map((tz) => tz.name);
